import {
  useMediaQuery,
  Box,
  Typography,
  IconButton,
  TextField,
  CardMedia,
  Button,
} from "@mui/material";
import AdminSidebar from "./AdminSidebar";
import { Description, Search, VideoLibrary } from "@mui/icons-material";
import color from "../../components/utils/Colors";
import { useNavigate } from "react-router-dom";

const AdminCourseDetails = () => {
  const isSmallScreen = useMediaQuery("(max-width:1050px)");

  const chapter = [
    {
      name: "Introduction",
      time: "45 mins",
    },
    {
      name: "Understanding UI/UX Design Principles",
      time: "1 hr",
    },
    {
      name: "Importance of User-Centered Design",
      time: "45 mins",
    },
    {
      name: "Importance of User-Centered Design",
      time: "25 mins",
    },
  ];

  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        backgroundImage: "url('/images/logo 2.svg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "auto",
        margin: isSmallScreen ? "10px" : "30px",
        marginTop: "0px",
        paddingTop: "20px",
        gap: "3%",
        borderRadius: "10px",
        flexDirection: isSmallScreen ? "column" : "row",
      }}
    >
      <AdminSidebar />

      <Box
        sx={{
          flex: 1,
          borderRadius: "16px",
        }}
      >
        {/* <TextField
          className="input-root2"
          placeholder="Search..."
          size="small"
          InputProps={{
            startAdornment: (
              <IconButton>
                <Search />
              </IconButton>
            ),
          }}
          sx={{
            width: { xs: "100%", md: "auto" },
          }}
        /> */}

        <Box
          sx={{
            position: "relative",
            background: color.firstColor,
            borderRadius: "16px",
            height: "fit-content",
            my: 4,
          }}
        >
          <Box
            component="img"
            src="/assets/Welcome Bar.svg"
            alt="Welcome Bar"
            sx={{
              width: "100%",
              height: 200,
              objectFit: "contain",
            }}
          />
          <Typography
            sx={{
              color: "white",
              position: "absolute",
              top: { xs: "18%", sm: "25%" },
              left: "3%",
              fontSize: "32px",
              fontWeight: "bold",
            }}
          >
            Course Details
          </Typography>
          <Typography
            sx={{
              color: "white",
              position: "absolute",
              left: "3%",
              maxWidth: "62%",
              top: { xs: "44%", sm: "50%" },
            }}
          >
            Review course from teachers
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: 1,
            flexWrap: "wrap",
            justifyContent: isSmallScreen ? "center" : "space-between",
            p: isSmallScreen ? 1 : 4,
            pt: 1,
            borderRadius: "12px",
          }}
        >
          <h2
            style={{
              color: color.textColor,
              textAlign: "center",
              width: "100%",
              paddingLeft: "10px",
              margin: "0px",
            }}
          >
            Python
          </h2>

          <CardMedia
            component="img"
            image="/assets/Video-img.png"
            alt="Course Video"
            sx={{
              // width: { xs: "100px", sm: "120px", md: "140px" },
              // height: { xs: "100px", sm: "120px", md: "140px" },
              backgroundColor: "transparent",
              p: 4,
              pt: 2,
            }}
          />

          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              gap: 2,
            }}
          >
            {chapter.map((item, index) => (
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                sx={{
                  padding: "8px",
                  border: "1.5px solid",
                  borderColor: color.borderColor,
                  borderRadius: "4px",
                  width: { xs: "100%", sm: "48%" },
                  background: "white",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <Typography
                    onClick={() => {
                      navigate("/courses-video-admin");
                    }}
                    sx={{
                      color: color.textColor,
                      pl: 1,
                      fontWeight: 600,
                      cursor:'pointer',
                      "&:hover": {
                        textDecoration: "underline",
                      },
                    }}
                  >
                    {item.name}
                  </Typography>

                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{ width: "100%" }}
                  >
                    <Box display="flex" gap={1}>
                      <IconButton sx={{ color: color.firstColor }}>
                        <VideoLibrary />
                      </IconButton>
                      <IconButton sx={{ color: color.firstColor }}>
                        <Description />
                      </IconButton>
                    </Box>

                    <Typography
                      variant="body1"
                      sx={{ color: color.textColor, fontWeight: "bold", pr: 2 }}
                    >
                      {item.time}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>

          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width={"100%"}
            mt={8}
          >
            <Button
              id="button"
              className="button"
              style={{ borderRadius: "4px" }}
            >
              Do not verify
            </Button>
            <Button id="button1" style={{ borderRadius: "4px" }}
              onClick={() => alert('Course Verified Successfully!')}>
              Verify
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AdminCourseDetails;
